import React from 'react';

const ExportIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8485 10.1914V4.2C20.8485 4.08954 20.759 4 20.6485 4L14.528 4"
        stroke="#AAA2AA"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M20.2663 4.58225L11.1515 13.697"
        stroke="#AAA2AA"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M12.0701 6.06471L4.55476 6.0033C4.33257 6.00148 4.15149 6.18109 4.15149 6.40328V20.6C4.15149 20.8209 4.33058 21 4.55149 21H18.7498C18.9714 21 19.1507 20.8199 19.1498 20.5983L19.1185 13.1479"
        stroke="#AAA2AA"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default ExportIcon;
